import React, {forwardRef, useImperativeHandle, useRef, useState} from 'react'
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Modal, Row} from "reactstrap"
import * as Yup from "yup";
import {useForm} from "react-hook-form";

// components
import {GenericButton} from "../../../../components/buttons/customButtons";
import {GenericTableButton} from "../../../../components/buttons/buttonsActions";
import Separator from "../../../../components/Separator";
import {LogHistoryModal} from "../../../../components/logHistory/logHistoryModal";
import Switch from "react-bootstrap-switch";

// labels
import {FORM, INTERNATIONAL, LB_BACKGROUND, LB_CODE,LB_STATUS, REQUIRED} from "../../../../components/i18n/i18n";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../../components/i18n/toolTips";
import {PH_BACKGROUND, PH_CODE} from "../../../../components/i18n/placeHolders";

// utils

// actions
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";

// services
import {getCurrentDateForCodeField} from "../../../../util/DateTools";
import {sectionService} from "../../../../jwt/_services/landings/sectionService";
import SectionLangs from "../../../landings/section/_langs";


export const SectionsSectionForm = forwardRef((props, ref) => {
    const path = props.path + "/section";
    const [app] = useState(props.app || null);

    const [domainObject, setDomainObject] = useState(null);
    const [parent, setParent] = useState(null);
    const [translatableLangs, setTranslatableLangs] = useState( []);
    const [langs, setLangs] = useState( []);

    const [data, setData] = useState( {});
    const [status, setStatus] = useState(domainObject?.status || true);
    const [editMode, setEditMode] = useState(false);
    const [showModal, setShowModal] = useState(false)

    const modalRef = useRef(null);

    useImperativeHandle(ref, () => ({
        showModal(_item, _max, _parent) {
            const autocode = `SECTION_` + getCurrentDateForCodeField();
            setParent( _parent );

            if ( !_item?.id ) {
                setData({
                    id: null,
                    uid: null,
                    code: autocode.toUpperCase(),
                    background: null,
                    title: '---' ,
                    showOrder: _max + 1,
                });
                setLangs([]);
                setTranslatableLangs([]);
                setStatus( true );
            } else {
                setDomainObject(_item);
                setEditMode(true);
                setData({
                    id: _item?.id ,
                    uid: _item?.uid ,
                    code: _item?.code ,
                    background: _item?.background ,
                    title: _item?.title ,
                    showOrder: _item?.showOrder,
                });
                setLangs(_item?.langs || []);
                setTranslatableLangs(_item?.translatedLangs || [])
                setStatus(_item?.status);
            }

            setShowModal(true);
        }
    }));

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED ),
    });

    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
        }
    });

    const onSubmit = async (_data, _) => {
        const dataRequest = {
            fbDataBase : {id: app?.fbDataBase?.id},
            item: {
                ...data,
                ..._data,
                status,
                event : { id: parent?.id },
                langs,
            }
        }

        if (!editMode) {
            // console.log('save',  dataRequest);
            // return;
            genericIndexedActions.save(path, sectionService, dataRequest, closeForm)
        }
        else {
            let id = domainObject.id;
            dataRequest.item.id = domainObject?.id

            // console.log('update',  dataRequest);
            // return;
            genericIndexedActions.update(path, sectionService, id, dataRequest, closeForm)
        }
    };

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }


    const closeForm = () => {
        setDomainObject(null);
        setEditMode(false);
        setData({
            id: null,
            uid: null,
            code: null,
            background: null,
            showOrder: null,
        });
        reset();
        setShowModal(false);
    }


    return <Modal
        isOpen={showModal}
        toggle={_ => setShowModal(!showModal)}
        keyboard={false}
        modalClassName="menu-modal-form"
    >
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Card className={'card-modal'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <>
                        <h2 className={'card-modal-title'} > { (domainObject?.title || domainObject?.name || '') }</h2>
                        <br />
                        <h5 className={'card-modal-uid'} > { '     uid: ' + (domainObject?.uid || '') }</h5>
                    </>
                    <div className={'top-right'}>
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            type={'submit'}
                        />
                        {
                            editMode && <>
                                <GenericTableButton
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                            </>
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={closeForm}
                        />
                    </div>
                </CardTitle>
                <CardBody className={'card-body-modal'}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>{LB_CODE}</Label>
                                <Input
                                    type="text"
                                    name="code"
                                    placeholder={PH_CODE}
                                    innerRef={register}
                                    defaultValue={data.code}
                                    onChange={e => setData({ ...data, code: e.target.value })}
                                />
                                {errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>{'Orden'}</Label>
                                <Input
                                    type="number"
                                    step={1}
                                    name="showOrder"
                                    innerRef={register}
                                    defaultValue={data.showOrder}
                                    onChange={e => setData({ ...data, showOrder: e.target.value })}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{LB_STATUS}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={status}
                                    onChange={ () => setStatus(!status) }
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>{LB_BACKGROUND}</Label>
                                <Input
                                    type="text"
                                    name="background"
                                    placeholder={PH_BACKGROUND}
                                    innerRef={register}
                                    defaultValue={data.background}
                                    onChange={e => setData({ ...data, background: e.target.value })}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>
                        { INTERNATIONAL }
                    </CardTitle>
                    <CardBody>
                        <SectionLangs
                            langs={langs}
                            setLangs={setLangs}
                            translatableLangs={translatableLangs}
                        />
                    </CardBody>
                </CardBody>

                {/*{*/}
                {/*    showModal && <LogHistoryModal*/}
                {/*        ref={modalRef}*/}
                {/*        item={domainObject}*/}
                {/*    />*/}
                {/*}*/}
            </Card>
        </Form>
    </Modal>
})
